<template>
  <div>
    <el-row style="margin-bottom: 8px;">
      <el-input class="search-el" size="small" v-model="query.mobile" placeholder="手机号"></el-input>
      <el-input class="search-el" size="small" v-model="query.give_content" placeholder="赠送ID"></el-input>
      <el-input class="search-el" size="small" v-model="query.user_code" placeholder="用户唯一码"></el-input>
      <el-select class="search-el" size="small" v-model="query.type" placeholder="类型">
        <el-option label="全部类型" value=""></el-option>
        <el-option label="课程发放" value="3"></el-option>
        <el-option label="优惠券发放" value="2"></el-option>
        <el-option label="会员发放" value="1"></el-option>
        <el-option label="商品发放" value="6"></el-option>
      </el-select>
      <el-select class="search-el" size="small" v-model="query.source" placeholder="订单来源">
        <el-option label="全部来源" value=""></el-option>
        <el-option label="抖音直播" value="backend_activity_import_dy"></el-option>
        <el-option label="视频号直播" value="backend_activity_import_wxvideo"></el-option>
        <el-option label="抖音短视频" value="backend_activity_import_dy_short"></el-option>
        <el-option label="视频号短视频" value="backend_activity_import_wxvideo_short"></el-option>
        <el-option label="其他" value="backend_activity_import_others"></el-option>
        <el-option label="百度投放" value="backend_activity_import_bd_launch"></el-option>
        <el-option label="抖音投放" value="backend_activity_import_dy_launch"></el-option>
        <el-option label="公众号投放" value="backend_activity_import_gzh_launch"></el-option>
        <el-option label="小红书" value="backend_activity_import_xiaohongshu"></el-option>
        <el-option label="快手" value="backend_activity_import_kuaishou"></el-option>
      </el-select>
    </el-row>
    <el-row style="margin-bottom: 8px;">
      <el-date-picker class="search-el" size="small" v-model="query.date_timestamp" value-format='yyyy-MM-dd HH:mm:ss'
        type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="primary" size="small" @click="getList()">
        查询
      </el-button>
      <el-button icon="el-icon-s-management" type="primary" plain size="small" @click="showDialog(3)">
        导入课程
      </el-button>
      <el-button icon="el-icon-s-ticket" type="success" plain size="small" @click="showDialog(2)">
        导入优惠券
      </el-button>
      <el-button icon="el-icon-s-custom" type="warning" plain size="small" @click="showDialog(1)">
        导入会员
      </el-button>
      <el-button icon="el-icon-s-custom" type="info" plain size="small" @click="showDialog(6)">
        导入商品
      </el-button>
      <span style="margin-left: 10px">新用户：{{ newUser }} 老用户：{{ oldUser }}</span>
    </el-row>

    <el-row v-loading='revokeLoading'>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" align="center" width="110"></el-table-column>
        <el-table-column prop="user_id" label="用户ID" align="center"></el-table-column>
        <el-table-column prop="give_type" label="类型" align="center"></el-table-column>
        <el-table-column prop="give_title" label="内容" align="center" width="300"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="give_title_id" label="内容ID" align="center"></el-table-column>
        <el-table-column label="新用户" align="center">
          <template slot-scope="{row}">
            <div>
              <span v-if="row.is_new_user == 1" style="color:#67C23A"><i class='el-icon-user-solid'></i> 新用户</span>
              <span v-else style="color:#909399"><i class='el-icon-user'></i> 老用户</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="old_end_at" label="发放前到期时间" align="center" width="90"></el-table-column>
        <el-table-column prop="updated_at" label="处理时间" align="center" width="90"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{row}">
            <div>
              <template v-if="row.give_status == 1">
                <template v-if="row.exception_message != null">
                  <span style="color:#F56C6C">已处理</span>
                </template>
                <template v-else>
                  <span style="color:#67C23A">已处理</span>
                </template>
              </template>
              <template v-else-if="row.give_status == 2">
                <span style="color:#909399">已撤销</span>
              </template>
              <template v-else-if="row.give_status == 0">
                <span style="color:#909399">待处理</span>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" label="金额" align="center"></el-table-column>
        <el-table-column prop="user_code" label="用户唯一码" align="center"></el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{row}">
            <template v-if="row.order_id != null && row.give_type != '商品发放'">
              <el-button type="danger" size="small" @click="revoke(row.id)" v-if="row.give_status == 1">
                撤销
              </el-button>
              <span style="color:#909399" v-else-if="row.give_status == 2">已撤销</span>
            </template>
            <template v-else>
              {{ row.exception_message }}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination background @current-change="getList" :current-page.sync="query.page" :page-size="query.limit"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>

    <el-dialog title="待处理列表" :visible.sync="importDialog" width="80%" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-button icon="el-icon-warning-outline" size="small" plain @click="showImportInfo()">
        导入{{ list2Query.type == 3 ? '课程' : (list2Query.type == 2 ? '优惠券' : (list2Query.type == 6 ? '商品' : '会员')) }}操作提示
      </el-button>
      <el-button type="info" icon="el-icon-download" size="small" @click="downloadTemplate()">
        下载模板
      </el-button>
      <el-button size="small" icon="el-icon-upload" type="primary" @click="uploadFileDialog = true">导入模板</el-button>
      <el-button type="warning" icon="el-icon-receiving" size="small" @click="handleInfoGive()"
        :loading="handleInfoGiveLoading">
        开始处理
      </el-button>
      <el-button type="danger" icon="el-icon-delete" size="small" @click="delActivityGiveLog('a', list2Query.type, '')"
        :loading="delActivityGiveLogLoading">
        删除全部
      </el-button>
      <el-button plain icon="el-icon-refresh" size="small" @click="getList2()" :loading="list2Loading">
        刷新
      </el-button>
      <h4 v-show="handleInfoGiveLoading"><i class="el-icon-loading"></i> 处理中... ({{ sec }}秒后自动刷新列表)</h4>
      <el-table v-loading="list2Loading" :data="list2" border size="mini" :stripe="true"
        style="width: 100%; margin: 20px 0">
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
        <el-table-column prop="user_id" label="用户ID" align="center"></el-table-column>
        <el-table-column prop="give_type" label="类型" align="center"></el-table-column>
        <el-table-column prop="give_title" label="内容" align="center"></el-table-column>
        <el-table-column prop="give_title_id" label="内容ID" align="center"></el-table-column>
        <el-table-column label="新用户" align="center">
          <template slot-scope="{row}">
            <div>
              <span v-if="row.is_new_user == 1" style="color:#67C23A"><i class='el-icon-user-solid'></i> 新用户</span>
              <span v-else style="color:#909399"><i class='el-icon-user'></i> 老用户</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="old_end_at" label="发放前到期时间" align="center" width="200"></el-table-column>
        <el-table-column prop="updated_at" label="处理时间" align="center" width="200"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{row}">
            <div>
              <span v-if="row.give_status == 1" style="color:#67C23A">已处理</span>
              <span v-else style="color:#909399">待处理</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" label="金额" align="center"></el-table-column>
        <el-table-column prop="user_code" label="用户唯一码" align="center"></el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="{row}" v-if="row.give_status == 0">
            <el-button type="danger" size="small" @click="delActivityGiveLog('s', list2Query.type, row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination background @current-change="getList2" :current-page.sync="list2Query.page"
          :page-size="list2Query.limit" layout="total, prev, pager, next, jumper" :total="list2Total">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog title="上传文件" :visible.sync="uploadFileDialog" :close-on-click-modal="false"
      :close-on-press-escape="false" width="40%">
      <el-input title="上传文件" type="textarea" :autosize="{ minRows: 4, maxRows: 40 }" placeholder="请输入发放理由，需大于5个字，小于100个字"
        v-model="uploadActionData.reason">
      </el-input>
      <el-upload class="upload-demo" :action="uploadAction" :headers="uploadActionHeaders" :data="uploadActionData"
        name="import" :multiple="false" drag :on-success="uploadSuccessFun" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <!-- <el-button size="small" icon="el-icon-upload" type="primary">导入模板</el-button> -->
      </el-upload>
    </el-dialog>

    <el-drawer title="操作提示" size="50%" :visible.sync="showImportDrawer">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="导入课程" name="3">
          <ul>
            <li>* [ <i class="el-icon-thumb"></i> 下载模板] -> <i class="el-icon-edit-outline"></i> 去掉演示数据 -> <i
                class="el-icon-edit-outline"></i> 添加内容 -> [ <i class="el-icon-thumb"></i> 导入模板] -> <i
                class="el-icon-finished"></i> 验证数据无误 -> [ <i class="el-icon-thumb"></i> 开始处理]
            </li>
            <li>* <b>请不要修改表头，修改表头后无法导入！</b></li>
            <li>* <b>处理任务开始无法中断！请仔细确认数据！</b></li>
            <li>* 多次录入同一手机号 不同课程ID，可实现同一用户发放多门课程</li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【手机号 *】11位手机号（新用户使用此手机号注册灵动生活）
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【课程ID或排期ID*】（后台查询课程ID或排期ID）
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【实付金额*】大于0元
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【课程类型*】普通课或专题课或排期课
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【订单来源*】抖音、视频号、其他 等
            </li>
            <li>
              <el-tag size="mini" type="info">非必填</el-tag>
              【导购用户唯一码】生成订单时使用此用户作为导购（用户管理->用户列表->唯一码）
            </li>
            <li>
              <el-tag size="mini" type="info">非必填</el-tag>
              【短信模板】支持以下短信
              <div style="padding-left:81px">
                [ <b>发放课程模板</b> ] 您在直播间获得的课程已经开通到您的灵动生活APP账号，请尽快至：灵动生活APP-我的-已购-课程目录内 添加助教进行学习
              </div>
              <div style="padding-left:81px">
                [ <b>直播间购买短信</b> ]
                您在视频号直播间购买的课程已开通，请点击链接https://wap.zhangdefenspace.com/appPage/AppDownload.html?user_code%3D5
                下载灵动生活APP到我的已购进行查看！
              </div>
              <div style="padding-left:81px">
                [ <b>直播间中奖短信</b> ]
                您在直播间获得的礼品已开通，请点击链接https://wap.zhangdefenspace.com/appPage/AppDownload.html?user_code%3D5
                下载灵动生活APP到我的已购进行查看！
              </div>
              <div style="padding-left:81px">
                [ <b>抖音直播购买短信</b> ] 亲爱的，您在抖音“灵动生活”购买的课程已开通，请点击https://sourl.cn/wiBhtV下载灵动生活到我的已购查看
              </div>
            </li>

          </ul>
        </el-collapse-item>
        <el-collapse-item title="导入优惠券" name="2">
          <ul>
            <li>* [ <i class="el-icon-thumb"></i> 下载模板] -> <i class="el-icon-edit-outline"></i> 去掉演示数据 -> <i
                class="el-icon-edit-outline"></i> 添加内容 -> [ <i class="el-icon-thumb"></i> 导入模板] -> <i
                class="el-icon-finished"></i> 验证数据无误 -> [ <i class="el-icon-thumb"></i> 开始处理]
            </li>
            <li>* <b>请不要修改表头，修改表头后无法导入！</b></li>
            <li>* <b>处理任务开始无法中断！请仔细确认数据！</b></li>
            <li>* <b>多次导入相同模板数据，会出现重复数据，重复赠送问题</b></li>
            <li>* 多次录入同一手机号 相同优惠券ID，可实现同一用户同一优惠券发放多张（例如：给用户发放638,639各3张，则录入三行相同手机号与三行638,639）</li>
            <li>* 同一用户 多次录入可发放多次</li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【手机号*】11位手机号
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【优惠券ID*】“,”英文逗号分隔，例：638,639（后台查询优惠券ID）
            </li>
          </ul>
        </el-collapse-item>
        <el-collapse-item title="导入会员" name="1">
          <ul>
            <li>* [ <i class="el-icon-thumb"></i> 下载模板] -> <i class="el-icon-edit-outline"></i> 去掉演示数据 -> <i
                class="el-icon-edit-outline"></i> 添加内容 -> [ <i class="el-icon-thumb"></i> 导入模板] -> <i
                class="el-icon-finished"></i> 验证数据无误 -> [ <i class="el-icon-thumb"></i> 开始处理]
            </li>
            <li>* <b>请不要修改表头，修改表头后无法导入！</b></li>
            <li>* <b>处理任务开始无法中断！请仔细确认数据！</b></li>
            <li>* 多次录入同一手机号 相同会员类型，可实现同一用户发放多次会员（例如：发放两年，则录入两行相同手机号数据，都选择年会员类型）</li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【手机号*】11位手机号
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【会员类型*】支持：年会员，季会员，月会员，半月会员
            </li>
            <li>
              <el-tag size="mini" type="info">非必填</el-tag>
              【实付金额】可以为空，为空默认为0元
            </li>
            <li>
              <el-tag size="mini" type="info">非必填</el-tag>
              【导购用户唯一码】生成订单时使用此用户作为导购（用户管理->用户列表->唯一码）
            </li>
          </ul>
        </el-collapse-item>
        <el-collapse-item title="导入商品" name="6">
          <ul>
            <li>* [ <i class="el-icon-thumb"></i> 下载模板] -> <i class="el-icon-edit-outline"></i> 去掉演示数据 -> <i
                class="el-icon-edit-outline"></i> 添加内容 -> [ <i class="el-icon-thumb"></i> 导入模板] -> <i
                class="el-icon-finished"></i> 验证数据无误 -> [ <i class="el-icon-thumb"></i> 开始处理]
            </li>
            <li>* <b>请不要修改表头，修改表头后无法导入！</b></li>
            <li>* <b>处理任务开始无法中断！请仔细确认数据！</b></li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【灵动生活手机号*】灵动生活用户11位手机号（新用户使用此手机号注册灵动生活）
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【收货人*】收货人姓名
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【收货人手机号*】收货人手机号
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【收货地址*】收货地址，例:浙江杭州西湖区浙大路38号
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【商品规格ID*】商品SKU ID（商品管理->商品规格->ID）
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【购买数量*】用户购买数量
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【实付金额*】用户订单实付金额
            </li>
            <li>
              <el-tag size="mini" type="danger">必填</el-tag>
              【订单来源*】抖音、视频号、其他
            </li>
            <li>
              <el-tag size="mini" type="info">非必填</el-tag>
              【导购用户唯一码】生成订单时使用此用户作为导购（用户管理->用户列表->唯一码）
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </el-drawer>
  </div>
</template>

<script>
import {
  getActivityGiveList, delActivityGiveLog, handleInfoGive, revokeGiveCourse
} from "@/api/activityGive";
// import { setInterval } from 'timers';

export default {
  data: function () {
    return {
      revokeLoading: false,
      uploadAction: '/backend/activity/importInfoGiveCourse',
      uploadActionHeaders: {
        'AdminId': Number(window.localStorage.getItem('admin_id'))
      },
      uploadActionData: {
        reason: '',
      },
      timeId1: '',
      sec: 3,
      delActivityGiveLogLoading: false,
      handleInfoGiveLoading: false,
      uploadFileDialog: false,
      fileList: [],
      list: [],
      list2: [],
      loading: false,
      list2Loading: false,
      total: 0,
      list2Total: 0,
      importDialog: false,
      showImportDrawer: false,
      activeNames: ['3'],
      list2Query: {
        page: 1,
        limit: 20,
        type: "",
        mobile: "",
      },
      query: {
        page: 1,
        limit: 20,
        type: "",
        mobile: "",
        give_content: "",
        user_code: "",
        source: "",
      },
      newUser: 0,
      oldUser: 0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  created: function () {
    if (Number(window.localStorage.getItem('admin_id')) <= 0) {
      this.$alert('请重新登录管理后台', '警告', {
        type: 'error',
        showClose: false,
        showConfirmButton: false,
      });
      return false;
    } else {
      this.getList();
    }
  },
  methods: {
    revoke (id) {
      this.$confirm('此操作将触发 订单退款；移除用户课程；分润返还 等逻辑，是否确认撤销？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.revokeLoading = true
        revokeGiveCourse({
          id
        }).then(res => {
          this.revokeLoading = false
          if (res.code == 1) {
            this.$message({
              showClose: true,
              duration: 6000,
              message: '操作成功',
              type: 'success'
            });
            this.getList();
          }
        });
      }).catch(() => {

      });
    },
    handleInfoGive () {
      var that = this
      this.getList2();
      this.$message({
        showClose: true,
        duration: 6000,
        message: '开始处理',
        type: 'success'
      });
      handleInfoGive({
        type: this.list2Query.type
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            showClose: true,
            duration: 6000,
            message: res.message,
            type: 'error'
          });
        } else {
          that.handleInfoGiveLoading = true
          var tempNum = 0;
          var tempTotal = 0;
          that.timeId1 = window.setInterval(() => {
            that.sec = (that.sec - 0.1).toFixed(1)
            if (that.sec <= 0) {
              that.getList2();
              that.sec = 3

              tempNum += 1
              tempTotal = that.list2Total
              if (tempTotal == that.list2Total && tempNum > 3) {
                that.$message({
                  showClose: true,
                  duration: 6000,
                  message: '检测部分课程无法处理请删除，或联系技术部',
                  type: 'success'
                });
                that.handleInfoGiveLoading = false
                clearInterval(that.timeId1)
              }
            }
            if (that.list2Total == 0) {
              that.$message({
                showClose: true,
                duration: 6000,
                message: '处理完成',
                type: 'success'
              });
              that.handleInfoGiveLoading = false
              clearInterval(that.timeId1)
            }
          }, 100)
        }
      });
    },
    delActivityGiveLogAction (del, type, id) {
      delActivityGiveLog({
        del,
        type,
        id
      }).then(() => {
        if (del == 'a') {
          this.delActivityGiveLogLoading = false
        }
        this.getList2();
        this.$message({
          showClose: true,
          duration: 6000,
          message: '操作成功',
          type: 'success'
        });
      });
    },
    delActivityGiveLog (del, type, id) {
      if (del == 'a') {
        this.delActivityGiveLogLoading = true
        this.$confirm('此操作将删除全部待处理内容（删除后可重新导入）是否确定删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delActivityGiveLogAction(del, type, id)
        }).catch(() => {
          this.delActivityGiveLogLoading = false
        });
      } else {
        this.delActivityGiveLogAction(del, type, id)
      }
    },
    uploadSuccessFun (res) {
      if (res.code == 0) {
        this.$message({
          showClose: true,
          duration: 6000,
          message: res.message,
          type: 'error'
        });
      } else {
        this.getList2();
        this.uploadFileDialog = false
        this.uploadActionData.reason = ''
        this.$message({
          showClose: true,
          duration: 6000,
          message: '导入成功，检查无误后点击[开始处理]。',
          type: 'success'
        });
      }
      this.fileList = [];
    },
    showImportInfo () {
      this.activeNames = [this.list2Query.type.toString()];
      this.showImportDrawer = true
    },
    downloadTemplate () {
      if (this.list2Query.type == 3) {
        window.open('https://res.defen.hzxinquanzi.com/activity/%E8%AF%BE%E7%A8%8B%E5%8F%91%E6%94%BE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls?v=' + Math.random());
      } else if (this.list2Query.type == 2) {
        window.open('https://res.defen.hzxinquanzi.com/activity/%E4%BC%98%E6%83%A0%E5%88%B8%E5%8F%91%E6%94%BE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls?v=' + Math.random());
      } else if (this.list2Query.type == 6) {
        window.open('https://res.defen.hzxinquanzi.com/activity/%E5%95%86%E5%93%81%E5%8F%91%E6%94%BE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls?v=' + Math.random());
      } else {
        window.open('https://res.defen.hzxinquanzi.com/activity/%E4%BC%9A%E5%91%98%E5%8F%91%E6%94%BE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls?v=' + Math.random());
      }
    },
    showDialog (type) {
      this.importDialog = true;
      this.list2Query.type = type;
      this.list2Query.status = 0;
      if (type == 3) {
        this.uploadAction = '/backend/activity/importInfoGiveCourse'
      } else if (type == 2) {
        this.uploadAction = '/backend/activity/importInfoGiveCoupon'
      } else if (type == 6) {
        this.uploadAction = '/backend/activity/importInfoGiveProduct'
      } else {
        this.uploadAction = '/backend/activity/importInfoGiveVip'
      }
      this.getList2();
    },
    ref () {
      window.history.go(0);
    },
    getList () {
      this.loading = true;
      getActivityGiveList(this.query).then(response => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.newUser = response.data.new_user;
        this.oldUser = response.data.old_user;
        this.loading = false;
      });
    },
    getList2 () {
      this.list2Loading = true;
      getActivityGiveList(this.list2Query).then(response => {
        this.list2 = response.data.list;
        this.list2Total = response.data.total;
        this.list2Loading = false;
      });
    }
  }
};
</script>

<style>
.el-upload {
  display: block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  margin-top: 20px;
}

.el-upload-dragger {
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100%;
  height: 180px;
  text-align: center;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}

.el-drawer__body {
  padding: 20px;
}
</style>
